import ApiResponseType from '@/Shared/Hook/ApiResponseType'

export default function () {
    const get = (url: string): Promise<ApiResponseType> => {
        return sendRequest('get', url)
    }

    const post = (url: string, data: FormData): Promise<ApiResponseType> => {
        return sendRequest('post', url, data)
    }

    const sendRequest = (
        method: 'get' | 'post',
        url: string,
        data: FormData | null = null,
    ): Promise<ApiResponseType> => {
        return new Promise(
            (
                resolve: (value: ApiResponseType) => void,
                reject: (value: ApiResponseType) => void,
            ) => {
                const request = new XMLHttpRequest()

                request.onreadystatechange = function () {
                    if (this.readyState === XMLHttpRequest.DONE) {
                        const json = JSON.parse(
                            this.response ? this.response : '{}',
                        )

                        const apiFormResponse = new ApiResponseType(json)
                        const httpStatusCode = this.status

                        if (httpStatusCode >= 200 && httpStatusCode < 300) {
                            resolve(apiFormResponse)

                            return
                        }

                        resolve(apiFormResponse)
                    }
                }

                request.open(method, url, true)
                request.withCredentials = true
                request.setRequestHeader('Accept', 'application/json')
                request.send(data)
            },
        )
    }

    return { get, post }
}
